import {ChartYears} from "../ChartYears";
import {ChartDivisions} from "../ChartDivisions";
import {PeoplePublications} from "../PeoplePublications";
import {FiltersDto} from "../../generated/api";

interface LayoutProps {
    filters: FiltersDto
    refreshKey: number
}

export function DefaultLayoutWithMetrics(props: LayoutProps) {
    return <>
        <div style={{display: "flex", flex: 1}} className={"analytics-page"}>
            <div style={{display: "flex", flexDirection: "column", minWidth: 400, width: "40%"}}>
                <ChartYears filters={props.filters} refreshKey={props.refreshKey}/>
                <ChartDivisions filters={props.filters} refreshKey={props.refreshKey} metrics={true}/>
            </div>
            <PeoplePublications filters={props.filters} refreshKey={props.refreshKey} metrics={true}/>
        </div>
    </>
}